import { BaseService } from '../../../infra/base.service'
import { FormV2FormSignaturesRepository } from './form-v2-form-signatures.repository'
import type { FormV2FormSignature } from './form-v2-form-signature'

export class FormV2FormSignaturesService extends BaseService<FormV2FormSignature> {
    constructor(private rep: FormV2FormSignaturesRepository) {
        super(rep)
    }

    async publicGetOne(formV2FormSignatureId: string, token: string) {
        return await this.rep.publicGetOne(formV2FormSignatureId, token)
    }

    async publicSign(formV2FormSignatureId: string, token: string, dto: { document: string; geolocation: any }) {
        return await this.rep.publicSign(formV2FormSignatureId, token, dto)
    }

    async resendEmail(formV2FormSignatureId: string) {
        return await this.rep.resendEmail(formV2FormSignatureId)
    }
}
